import { createReducer, createSelector } from 'redux-starter-kit';
import { putNormalizedInspectionNote, addNormalizedInspectionNotes } from './inspectionNoteActions';
import { selectUser } from '../users/userReducer';


/**
 * A selector for the inspection notes loaded in the domain state.
 * This is a keyed object: { noteId: note }
 * @param {object} state The redux state of the application.
 */
export const selectInspectionNotesMap = state => state.via.domain.inspectionNotes;

/**
 * A selector for the inspection notes loaded in the domain state.
 * This is an array: [note, note, ...]
 * @param {object} state The redux state of the application
 * @returns An array of inspection notes.
 * @example const notes = selectInspectionNotes(state);
 */
export const selectInspectionNotes = createSelector(['via.domain.inspectionNotes'], map => (map ? Object.values(map) : null));

/**
 * A selector for an inspection note that is loased in the domain state.
 * @param {object} state The redux state of the application.
 * @param {number} noteId The id of the inspection note.
 */
export const selectInspectionNote = (state, noteId) => {
  const noteMap = selectInspectionNotesMap(state);
  if (!noteMap) return null;

  const normalizedNote = noteMap[noteId];
  return {
    ...normalizedNote,
    createdByUser: selectUser(state, normalizedNote.createdByUser),
  };
};


const initialInspectionNotes = {
  // noteId: { /* note object */ }
  // noteId: { /* note object */ }
  // ...etc
};

export default createReducer(initialInspectionNotes, {
  // Puts an inspection note into the store.
  [putNormalizedInspectionNote]: (state, action) => {
    const note = action.payload;

    return {
      ...state,
      [note.noteId]: note,
    };
  },

  // Adds inspection notes into the store.
  [addNormalizedInspectionNotes]: (state, action) => {
    const notes = action.payload;

    return notes.reduce((newState, note) => {
      newState[note.noteId] = note; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...state });
  },
});
